import React from 'react'
import { apiFetch } from '../../../fetchApi';

export const candidateUpdateSkill = ({ BeURL, id, topInput, setSkillList, showAlert, handleTopClear, setIsUpdating, candidateId}) => {
    if (!BeURL || !id || !topInput) {
        showAlert("Missing required data to update skill. Please try again.");
        return;
    }
    setIsUpdating(true)
    apiFetch(`${BeURL}/candidate-update-skill/${id}`, {
        method: 'PUT',
        credentials: 'include',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ skills: [topInput], candidateId }),
    })
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                showAlert(data.message)
                if (data.skills) {
                    setSkillList(data.skills)
                   
                }
                handleTopClear()
            }
            else {
                showAlert(data.message)
            }
        })
        .catch(err => {
            console.log("Error in skills updated", err)
        })
        .finally(() => setIsUpdating(false))
} 
